import { render, staticRenderFns } from "./CompanyArchives.vue?vue&type=template&id=99594e8a&"
import script from "./CompanyArchives.vue?vue&type=script&lang=js&"
export * from "./CompanyArchives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports